import type { UseButtonProps } from "./interface";

export function useButton({ variant = "primary", ...props }: UseButtonProps) {
  const buttonVariants = {
    primary: "text-white bg-[#4256C8] hover:bg-blue-500 cursor-pointer",
    disabled: "bg-[#E9EBED] text-[#C2C8CC] cursor-not-allowed",
    outline:
      "border border-[#4256C8] text-[#4256C8] bg-white hover:bg-blue-50 cursor-pointer",
    "outline-danger": "border border-[#CC3340] text-[#CC3340] hover:bg-[hsl(354,60%,50%,0.08)] cursor-pointer",
    danger: "bg-red-600 text-white hover:bg-red-700 cursor-pointer",
    "no-border": "border-0 bg-transparent text-[#4256C8] hover:bg-blue-50 cursor-pointer",
    "no-border-danger": "border-0 bg-transparent text-red-600 hover:bg-red-50 cursor-pointer",
  };

  const buttonStyle = props.disabled
    ? buttonVariants.disabled
    : buttonVariants[variant];

  return { buttonStyle };
}
